export const api = {
  login: 'users/userlogin/',
  register: 'users/registration/',
  location: {
    fetchProvinces: 'core/provinces/',
    fetchDistricts: 'core/districts/?',
    ethnicity: 'users/ethnicity/',
    serviceGroup: 'users/service-group/',
    serviceSubGroup: '/users/service-master-group/?search={serviceId}'
  },
  hall: {
    fetchHall: '/organization/hall'
  },
  userDetail: 'users/get-logged-in-user-profile/',
  trainee: {
    detail: 'users/detail/{traineeId}/',
    update: 'users/update-trainee/{traineeId}/',
    update_personal_detail: 'users/trainee/{traineeId}/personal-details/',
    get_personal_detail: '/users/trainee/{traineeId}/personal-details/',
    update_job_detail: '/users/trainee/{traineeId}/job-details/',
    get_job_detail: '/users/trainee/{traineeId}/job-details/',
    update_contact_detail: '/users/trainee/{traineeId}/contact-details/',
    get_contact_detail: '/users/trainee/{traineeId}/contact-details/',
    update_education_detail: '/users/trainee/{traineeId}/education-details/',
    get_education_detail: '/users/trainee/{traineeId}/education-details/',
    delete_education_detail: '/users/trainee/{id}/education-detail/{education_id}',
    update_extra_detail: '/users/trainee/{traineeId}/extra-data/',
    get_extra_detail: '/users/trainee/{traineeId}/extra-data/',
    create_experience: '/users/trainee/{id}/experience/',
    update_experience_detail: '/users/trainee/{id}/experience/{experience_id}',
    get_experience_detail: '/users/trainee/{traineeId}/experience/',
    create_training: '/users/trainee/{id}/training/',
    update_training_detail: '/users/trainee/{id}/training/{training_id}/',
    get_training_detail: '/users/trainee/{id}/training/'
  },
  discussion: {
    attachment:
      'routine_discussion/comments/attachment/?type=coursetopic&id={sessionId}&routine={routineId}',
    save: 'routine_discussion/comments/create/?type={courseTopic}&id={sessionId}',
    fetch: 'routine_discussion/comments/?type={courseTopic}&id={sessionId}&routine={routineId}',
    reply: {
      save: 'routine_discussion/comments/create/?type={courseTopic}&id={sessionId}&parent_id={parentId}'
    }
  },
  sendForgetPassword: 'users/request-reset-email/userID/2/',

  getResetToken: '/users/password-reset/:uid/:paramToken/',
  resetForgottenPass: '/users/password-reset-complete/',
  attendance: '/attendance/trainee/today-attendance/',
  fullAttendance: '/attendance/trainee/all-detail/',
  attendanceRequest: '/attendance/request-attendance/create/',
  traineeModule: '/training/course-list/',

  courseSession: '/training/course-session-list/{courseId}/',
  trainingRoutine: '/users/trainee/',
  routineById: '/training/trainee/routine-master/',
  dailySession: '/training/routine-master/',
  trainingDetail: '/training/trainee/routine-training-course/list',
  routineCourseSessionList: '/training/routine-course-session-list',
  lecturersbyModule: '/training/trainee/routine-course-session-list',
  adminDetailById: '/users/trainee/admindetail',
  dashboardCount: '/training/trainee/dashboard/count/',
  courseCategory: '/training/trainee/course-category-list/',
  courseDetailById: '/training/session-as-per-course/{courseId}/',
  allcourse: '/training/trainee/course-list/',
  courseEnroll: '/assignment/course/user_enrollment/',
  //api not ready yet, or might not be used
  onGoingCourse: '/',
  coursePerCategory: '/training/course-as-per-category/{category_id}/',
  resourcePerSession:
    '/training/course-session-resource-list/?course_topic={id}&resource_type={type}',
  assignmentsPerSession: '/assignment/trainee/?topic_id=:id',
  mcqPerAssignment: '/assignment/mcq/id/',
  sendAssignmentAnswer: '/assignment/id/answer/submission/',
  getMcqResult: '/assignment/trainee/quiz_result/assignment_id/',

  courseRoster: 'training/routine/roster/{routineId}/?course_id={courseId}',
  dailyFeedback: 'training/daily_session/today/',
  feedbackQuestion: 'training/routine_feedback_questions/',
  changePassword: '/users/change-password/',
  saveFeedbackAnswer: '/training/daily_session_feedback/create/',
  fetchFeedbackModule: '/training/course_session/feedback/',
  saveFeedbackModuleAnswer: '/training/course_feedback/create/',
  fetchLunchFeedbackModule: '/training/lunch/feedback/',
  fetchTrainingFeedback: '/training/training_feedback/',
  saveTrainingFeedbackAnswer: '/training/training_feedback/create/',
  saveLunchFeedbackAnswer: '/training/lunch_feedback/create/',
  // from here subisu apis
  loginUserDetail: 'api/web/user/getLoginUserDetail',
  changeUserPassword: 'api/web/user/changePassword',
  users: '/api/web/user/internal',
  userEdit: '/api/web/user/edit',
  singleUser: 'api/web/user/findOne/{id}',
  userImage: 'api/web/user/image/{id}',
  mobileUsers: '/api/web/user/mobile',
  toggleMobileUser: '/api/web/user/toggleUser/{id}',
  support: {
    save: '/api/support/case',
    fetch: '/api/support/case/{userId}'
  },

  category: {
    categoryList: 'api/support/categories',
    subCategoryList: 'api/support/sub-categories/{categoryId}'
  },

  resetPassword: '/api/mobile/login/generate-otp',
  otpVerification: '/api/mobile/login/verify-otp',
  forgetPassword: '/api/web/user/forget-password',

  roles: '/api/role',
  banner: {
    fetch: '/api/mobile/login/get-all-banner',
    save: '/api/mobile/login/save-banner',
    get: '/api/mobile/login/get-all-banner-by-language/{language}',
    delete: '/api/mobile/login/delete-banner/{id}'
  },
  dashboard: {
    fetch: '/api/dashboard/data/for/superadmin/dashboard',
    detail: '/api/dashboard/data/for/agent/dashboard',
    support: '/api/dashboard/data/for/support/user/dashboard'
  },
  internal: {
    agentUser: {
      save: '/api/user/agent',
      detail: '/api/user/agent/{agentId}',
      edit: '/api/user/agent/{id}'
    },
    supportUser: {
      save: '/api/user/support',
      detail: '/api/user/support/{supportId}'
    },
    changePassword: 'api/web/user/change/password'
  },
  office: {
    branch: {
      fetch: '/api/branch'
    }
  },
  mobile: {
    user: {
      customerDetail: '/api/mobile/login/customer/get-customer-data',
      profileImage: '/api/mobile/login/get-profile-image/{customerId}',
      uploadProfileImage: '/api/mobile/login/upload-profile-image',
      allAccountsDetails: '/api/mobile/login/customer/getCustomerOtherAccountDetails/{mobile}',

      paymentHistory: '/api/payment/get/payment/report',
      billing: '/api/support/invoice-history',
      payment: '/api/payment/get/payment/list',
      topUser: '/api/web/user/get/recent/top/users',
      switchAccount: '/api/mobile/login/customer/setDefaultAccount'
    },
    plans: {
      customerPlan: '/api/mobile/login/customer/getCustomerPlans/{customerId}'
    },
    router: {
      neighbouringWifi: '/api/mobile/router/neighboring-wifi/{ONUID}',
      opticalPower: '/api/mobile/router/optical-power/{ONUID}',
      signalStrength: '/api/mobile/router/signal-strength/{ONUID}',
      dhcp: '/api/mobile/router/dhcp-client/{ONUID}',
      deviceInfo: '/api/mobile/router/device-info/{ONUID}',
      wifiDetails: '/api/mobile/router/wifi-detail/{ONUID}',
      rebootRouter: '/api/mobile/router/reboot/{ONUID}',
      changePassword: '/api/mobile/router/change-password/{ONUID}'
    }
  }
  // till here subisu apis
};

export interface TMSResponse<T = any> {
  results: any;
  data: T;
  status: 0 | 1;
  message: string;
  first_login_attempt?: boolean;
}
